import React, { useState, useEffect, useCallback, useContext } from "react";
import { useFocusEffect } from '@react-navigation/native';
import {
  View,
  StyleSheet,
  KeyboardAvoidingView,
  Platform,
  Keyboard,
  FlatList,
} from "react-native";
//import { Video, Audio, AVPlaybackStatus } from 'expo-av';
//import { Image } from "react-native-expo-image-cache";
//import { MaterialCommunityIcons, 
        //  AntDesign, 
        //  Fontisto,
        //  Foundation, 
        //  Octicons, 
        //  FontAwesome5, 
        //  Entypo  } from "@expo/vector-icons";


import colors from "../config/colors";
//import Text from "../components/Text";
//import { TouchableWithoutFeedback, TouchableOpacity } from "react-native-gesture-handler";
import dateNow from "../utility/dateNow";
//import useAuth from "../auth/useAuth";
import routes from "../navigation/routes";
import connectionConfig from "../config/settings";
import configurationPost from "../config/configurationPost";
// import PickerActionsScreen from "./PickerActionsScreen";
// import CardSeed from "../components/CardSeed";
// import defaultStyles from "../config/styles";
// import * as Linking from 'expo-linking';


// import ActivityIndicator from "../components/ActivityIndicator";
// import CardComponent from "../components/CardComponent";
import CardEdit from "../components/CardEdit";
import AuthContext from "../auth/context";

const webUrl = connectionConfig.imageUrl + '/seedImages/'
var seedVideoUri = connectionConfig.imageUrl + '/Documents/videoSeeds/'   // 15 sep 2021 Esto lo paso al CardOriginComponent 
var infoDocumetUri =  connectionConfig.imageUrl +'/Documents/'


var pointer = 0
var blockSize = 30
var pageNumber = 0
var arrayActions = []
var date = dateNow()
let newSeedId = 0
var pickSeedId = 0
var fromShowActions = ''
var screenForSelectIfRenderOrNot = ''
var seedId = 0
var origin = 0
var seedOrder = 0


//---------- Agregado el martes 14 sep 2021 ---------
// Este campo es para que al rerenderizar para los likes desde el showActions nos deje se actualice el seedId
// para las busquedas tanto de contenido como de acciones. 
var transitionSeed = 0  
//------------------------------------------------------

//----------- Miércoles 15 de septiembre del 2021 --------------------------
// Variable para re-renderizar comments de seeds desde action de ShowActions
var rerenderShowActionsXComment = ''
//--------------------------------------------------------------------------


//--------- Pruebas V 30/7/21 ---------------
var arrayContents = []
//-------------------------------------------

var filtroListing = []

function ActionEditScreen({ route, navigation, type, seedId, seedDate, showUpAndDown }) {
  //debugger
  const [showActions, setShowActions] = useState("Show Actions");
  const { user } = useContext(AuthContext)
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [listing, setListing] = useState([]);

  var userId = JSON.parse(user).userId;


//------- Hooks para traer el contenido de cada Seed  ----------------
  const [content, setContent] = useState([]);
//--------------------------------------------------------------------

// variables necesarias para los videos:  
//----------------------------------------
const video =React.useRef(null);
const [status, setStatus] = useState({}); 
//----------------------------------------




var changeListing = true  // Esta variable hay que eliminarla en todo el código 10 agosto 2021


  const HEIGHT = 315.2727355957031
  //(Dimensions.get('window').height) * .5;
  const sizeItemLayout = ( item, index) => (
    {length: HEIGHT, offset: HEIGHT * index, index}
  );

  useFocusEffect(
    useCallback(() => {
        selectIfRenderOrNot() // Puse esta función por si se cambia acomodo de la foto en componentes 35, 36 y 37. Me permite detectar de donde viene y con base en eso traer de nuevo o no la info de la semilla.
        date = dateNow()
    }, [route.params.seedId, type])
  );

  type = route.params.type
  seedId = route.params.seedId
  origin = route.params.origin
  seedDate = route.params.seedDate
  userId = route.params.userId
  showUpAndDown = route.params.showUpAndDown
  seedOrder = route.params.seedOrder
  //seedPhoto = route.params.seedPhoto
  screenForSelectIfRenderOrNot = route.params.screen
  var itemsRequirements = route.params.itemsRequirements
  var userName = route.params.userName
  var userPhoto = route.params.userPhoto




  // Puse esta función por si se cambia acomodo de la foto en componentes 35, 36 y 37.
  // Me permite detectar de dónde viene y con base en eso traer de nuevo o no la info 
  // de la semilla.
  const selectIfRenderOrNot = async () => {
    if(screenForSelectIfRenderOrNot === "ChooseTypeContent"){
      renderActionOrComment()}
    else if(screenForSelectIfRenderOrNot === "CardOriginComponent"){renderActionOrComment()}
    else{null}
  } 

//----------------------------------------------------------------------------------------
//  Función para traer la info de la acción o contenido para su edición a agregar una más. 
//----------------------------------------------------------------------------------------
const renderActionOrComment = async () => {
    var post_values = {
      seedId: seedId
     }
    configurationPost.body = JSON.stringify(post_values)
    await fetch(connectionConfig.apiUrl+'/selectActionFromFlatlist/', configurationPost)
    .then(response => response.json())
    .then(response => { 
     var stringueoDelResponse = ([response]) // El Flatlist no queria responder entonces creo que necesitaba 
                                             // ponerle estos corchetes  
     //setContent(response)
     setContent(stringueoDelResponse)
     setLoading(false)
     changeListing = true
    })
    .catch(err =>{
    console.log(':( review internet service /selectActionFromFlatlist/', err )
    })
  
  }
  

//<ActivityIndicator visible={loading}/>
//debugger
var arregloPrueba = content // Esto lo hice para que jalara el Flatlist junto con ponerle corchete al response
                            // y tambien le quite el foundUserChecker al Flatlist.
// Este arreglo lo clave a fuercitas para ver si respondía el Flatlist y si respondió :)
// [{"brancheId": null,
// "createDateSeed": "2021/10/04 14:40:20",
// "documentSeed": null,
// "origin": 403,
// "path": null,
// "seedDescription": "A ver cuanto de transcripción de rollo 333",
// "seedFollowerId": 0,
// "seedId": 411,
// "seedName": "Veamos cuanto le puedo meter de Info. a ver si me acepta tantito más de título.",
// "seedPhoto": "197_2021-10-14_15:31:19_GenerateSeed.jpg",
// "totalActions": 0,
// "totalIdeaActions": 0,
// "totalInfoActions": 0,
// "totalSeedComments": 1,
// "totalSeedLikes": 2,
// "type": 1,
// "userId": 197,
// "youtubeId": null
// }]


// Funciones para cambiar el type de 35 a 36 o 37 según sea el caso
// Esto es para cambiar el arreglo de las fotos o video.
const setTypeTo35 = async () => {
  route.params.screen = " "
  route.params.type = 35        // Para que funcione CardEdit requiero modificar type desde la raíz  
  arregloPrueba[0].type = 35    // Tambien se debe modificar type en el arreglo del flatlist
  navigation.navigate(routes.ACTION_EDIT_SCREEN, { arregloPrueba }  ) // Con esta shulada se vuelve a renderizar ActionEditScreen con lo cual ya se actualiza el type.
  console.log("arregloPrueba en setTypeTo35 ", arregloPrueba )
}
const setTypeTo36 = async () => { 
  route.params.screen = " "
  route.params.type = 36
  arregloPrueba[0].type = 36
  navigation.navigate(routes.ACTION_EDIT_SCREEN, { arregloPrueba }  ) 
  console.log("arregloPrueba en setTypeTo36 ", arregloPrueba )
}
const setTypeTo37 = async () => {
  route.params.screen = " "
  route.params.type = 37
  arregloPrueba[0].type = 37
  navigation.navigate(routes.ACTION_EDIT_SCREEN, { arregloPrueba }  ) 
  console.log("arregloPrueba en setTypeTo37 ", arregloPrueba )
}


 return (
    <>
    <View style={styles.viewTop} >
    </View>
    <View style={styles.viewFlatlist}>
         <FlatList
          getItemLayout={sizeItemLayout}
          data={arregloPrueba}
          keyExtractor={(item) => item.seedId.toString()}
          initialScrollIndex={items.index}
          // onEndReachedThreshold={0.5}
          // onEndReached={() => getContentActions()}  

         // initialScrollIndex={route.params.index}
          
          renderItem={({ item, index}) => (
            // <View onLayout= {object => 
            //         itemHeights[index] = object.nativeEvent.layout.height}>
            
              <CardEdit
                type={item.type}  
                title={item.seedName}
                seedDescription={item.seedDescription}
                seedId={item.seedId}
                seedName={item.seedName} 
                seedPhoto={item.seedPhoto}
                origin={item.origin}
                subTitle={item.totalSeedLikes}
                videoNumber={item.youtubeId}
                documentSeed={item.documentSeed} 
                userId={userId}
                navigation={navigation}
                seedDate={seedDate}
                content={arregloPrueba}
                showUpAndDown={showUpAndDown}
                seedOrder={seedOrder}
                setTypeto35={() => {setTypeTo35()}}
                setTypeto36={() => {setTypeTo36()}}
                setTypeto37={() => {setTypeTo37()}}
                itemsRequirements={itemsRequirements}
                qty = { item.qty }
                mesure = { item.mesure }
                unitaryPrice = { item.unitaryPrice }
                currency = { item.currency }
                userName = { userName }
                userPhoto = { userPhoto }
                onPressNumLikes={() => {
                  indexLike = index
                  var pick = items[index].seedId
                  navigation.navigate(routes.LISTING_LIKE_USER_PUBLICATION, {pick}  );
                  console.log("presNumLique", indexLike)
                  }                  
                }
             
                imageUrl={
                  item.seedPhoto.includes('.mp4') ?
                  seedVideoUri + item.seedPhoto :
                  item.seedPhoto.includes('.mov') ?
                  seedVideoUri + item.seedPhoto :
                  webUrl + item.seedPhoto}
                
                onPressLike={ () => {
                  indexLike = index
                  //onPressValidationLikeUser()
                 }
                }
                commentsNum={item.totalSeedComments}
                actionsNum={item.totalActions}
                onPressComment={() => {
                  indexLike = index
                  var pick = items.seedId   //items[indexLike].seedId
                  navigation.navigate(routes.COMMENTS_SEEDS, {item, pick})
                  }
                }
                thumbnailUrl={webUrl + item.userId + '_' + item.seedPhoto}
                getDataFromSeedActions={() => {
                  pickSeedId =  items[index].seedId
                  //getDataFromSeedActions()
                  //navigation.navigate(routes.SEED_DETAILS, { pickSeedId }) //item
                  }
                }
              />
            //  </View>
          )}
        />
    </View>
    <View style={styles.viewBottom} >
    </View>
    </>
    
  );
}
    
const styles = StyleSheet.create({
    
  viewTop: {
    width: "100%",
   // height: "12%",
    marginBottom: "-2%",
    backgroundColor:  colors.fuente  // verde amarillento bonito "#BFB636",        //"#736B06", verde terrozo (popo)
  },
  viewFlatlist: {
  zIndex: 2,
  marginBottom: "0%",
  },
  viewBottom: {
    width: "100%",
    height: 600,
    marginBottom: "-2%",
    backgroundColor: colors.fuente   // verde amarillento bonito "#BFB636",         //"#D9BD32" amarillo terrozo             
  },
  
});

export default ActionEditScreen;
